module.exports = __webpack_public_path__ + "img/more.2f53c3ff.svg";